<template>
  <div id="app">
    <div v-if="canInstallApp" id="install-banner">
      <button class="btn btn-small btn-primary" @click="installApp">{{$resx('InstallAppText')}}</button>
      <a class="close" @click="closeInstallBanner">{{$resx('CloseText')}}</a>
    </div>
    <div class="container flex flex-stretch">
      <section id="content" class="flex">
        <div v-if="!isHomePage" class="menu-panel" :class="{active : isMenuOpen}">
          <button class="menu-toggle" @click="toggleMenu">
            <i class="material-icons open">menu</i>
            <i class="material-icons close">close</i>
          </button>
          <img class="logo" src="https://dyuzi43ld6cwm.cloudfront.net/luxe/img/fr/logo-big-transparent.png" alt="Campings.Luxe" />
          <app-menu></app-menu>
        </div>
        <div class="content-panel" :data-environment="environment">
          <header id="header" class="">
            <div class="user-bar">
              <span class="user-name" :data-color="userColor">
                <i class="material-icons">person</i> {{$resx('HelloText')}} {{partner.fullName}}
              </span>
              <ul class="user-actions">
                <li v-if="partner.isGroup"><button type="button" @click="showChooseCampingModal=true">{{$resx('MenuChangeCurrentCampsiteText')}}</button></li>
                <li><button type="button" @click="showChooseLanguageModal=true">{{$resx('MenuChangeCurrentLanguageText')}}</button></li>
                <li class="disconnect">
                  <form method="post" action="/logout">
                    <button type="submit" @click="onLogout">
                      <i class="material-icons">
                        exit_to_app
                      </i> {{$resx('MenuLogoutText')}}
                    </button>
                  </form>
                </li>
              </ul>
            </div>
          </header>
          <router-view></router-view>
        </div>
      </section>
      <select-language :show.sync="showChooseLanguageModal"></select-language>
      <select-campsite v-if="partner.isGroup" :show.sync="showChooseCampingModal"></select-campsite>
      <snackbar :config="snackbar" @close="onSnackClose"></snackbar>
    </div>
  </div>
</template>
<script>
import selectCampsite from './components/selectCampsite.vue'
import selectLanguage from './components/selectLanguage.vue'
import menu from './components/menu.vue'
import snackbar from './components/snackbar.vue'

export default {
  data () {
    return {
      showChooseCampingModal: false,
      showChooseLanguageModal: false, // https://andrewlock.net/adding-localisation-to-an-asp-net-core-application/
      deferredPrompt: null
    }
  },
  computed: {
    // compte partenaire connecté
    partner () {
      return this.$store.state.partner.account
    },
    // retourne si on est sur la home
    isHomePage () {
      return this.$store.state.app.page === 'home'
    },
    // retourne la couleur du texte pour le nom du partenaire
    userColor () {
      return this.isHomePage ? 'white' : ''
    },
    // retourne si le menu est ouvert
    isMenuOpen () {
      return this.$store.state.app.menuOpen
    },
    // objet qui gere l'affichage de message contextuel
    snackbar () {
      return this.$store.state.app.snackbar
    },
    // retourne si on peut afficher la barre d'install
    canInstallApp () {
      return this.$store.state.app.showInstallBanner
    },
    environment: function () {
      return this.$store.getters['app/isProduction'] ? '' : this.$store.state.app.environment
    }
  },
  methods: {
    // afffiche le panneau de menu
    toggleMenu () {
      this.$store.commit('app/toggleMenu')
    },
    // methode appelé par snackbar qd fermeture
    onSnackClose () {
      this.$store.commit('app/hideSnack')
    },
    // methode lors d'une cloture de session
    onLogout () {
      this.$store.commit('partner/delete')
    },
    // installer l'application
    installApp () {
      this.deferredPrompt.prompt()
    },
    // fermer la banniere d'install
    closeInstallBanner () {
      this.$store.commit('app/hideInstallBar')
    }
  },
  components:
  {
    'select-campsite': selectCampsite,
    'select-language': selectLanguage,
    'app-menu': menu,
    snackbar: snackbar
  },
  created: function () {
    var self = this

    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault()
      // Stash the event so it can be triggered later.
      self.deferredPrompt = e
      self.$store.commit('app/showInstallBanner')
    })

    // event qd l'appli est installée
    window.addEventListener('appinstalled', (event) => {
      self.closeInstallBanner()
    })
  }
}
</script>
